export default __webpack_public_path__ + "static/media/landscape6.210c672a.jpg";